import { useSelector } from 'store';
import { selectCowgSettingsMetadata, selectSettingsMetadata } from 'store/selectors/settings.selectors';

const SettingsService = {
  useCowgSettingsMetadata: () => useSelector(selectCowgSettingsMetadata),
  useSettingsMetadata: () => useSelector(selectSettingsMetadata),
};

export default SettingsService;
